import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { DifferenceSection } from './components/DifferenceSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PainPointsSection } from './components/PainPointsSection';
import { LevelsSection } from './components/LevelsSection';
import { MapAnatomySection } from './components/MapAnatomySection';
import { ProgressionSection } from './components/ProgressionSection';
import { BonusSection } from './components/BonusSection';
import { PracticeSection } from './components/PracticeSection';
import { SamplesSection } from './components/SamplesSection';
import { BonusPackSection } from './components/BonusPackSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
interface AppProps {
  showCountdownBar?: boolean;
  samplesLayout?: 'carousel' | 'grid';
}
export function App({
  showCountdownBar = true,
  samplesLayout = 'carousel'
}: AppProps) {
  React.useEffect(() => {
    initMetaPixel();
  }, []);
  React.useEffect(() => {
    const name = 'facebook-domain-verification';
    const content = 'prolx231v7pi554iedwsy1x0w8nc3c';
    let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="nxwv3et6z8sj">
      {showCountdownBar ? <UrgencyBar data-id="element-1" data-mp="ssstcwp0use3" /> : null}
      <Hero data-id="element-2" data-mp="36hzxgtw5a5z" />
      <main data-id="element-3" data-mp="35yp0k2nrm1g">
        <StatsBand data-id="element-4" data-mp="35ovimiemwr0" />
        <DifferenceSection data-id="element-5" data-mp="34x1vh8db93d" />
        <ComparisonSection data-id="element-6" data-mp="38b5essrpoce" />
        <PainPointsSection data-id="element-7" data-mp="3udawg7dqol46" />
        <LevelsSection data-id="element-8" data-mp="3ubzt28o7hfdl" />
        <MapAnatomySection data-id="element-9" data-mp="3ucjehzd2elwd" />
        <ProgressionSection data-id="element-10" data-mp="d4nv7fl6zi1v" />
        <BonusSection data-id="element-11" data-mp="d4xq9hl3gfef" />
        <PracticeSection data-id="element-12" data-mp="d45t42bum9m1" />
        <SamplesSection layout={samplesLayout} data-id="element-13" data-mp="d2bibguajxvo" />
        <BonusPackSection data-id="element-14" data-mp="86mf93j2byum" />
        <OfferSection data-id="element-15" data-mp="864djrdmssfb" />
        <GuaranteeSection data-id="element-16" data-mp="83qihiiybg7r" />
        <TestimonialsSection data-id="element-17" data-mp="3gkv01pfcflc8" />
        <FaqSection data-id="element-18" data-mp="3gm66jx06b771" />
        <FinalCtaSection data-id="element-19" data-mp="3glo2ie79rook" />
      </main>
      <Footer data-id="element-20" data-mp="3bmjo995hn0rd" />
    </div>;
}